import {AxiosPromise} from 'axios';
import FormData from 'form-data';

import {CONTACTS} from 'constants/actions';
import {ActionType} from '@typescript/common/actionTypes';
import {ENDPOINTS} from 'constants/endpoints';
import {HTTP_REQUEST_HEADER, HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE} from 'constants/api';
import {DataType} from 'containers/contacts/contacts';
import {instanceGusaBackend} from 'libs/api';

/**
 * Starts saga which sends users data to backend
 * @param {DataType} validatedDataFromContactsPageForm - Received form data
 * @returns {ActionType<DataType>} - Returned action
 */
export const startSendFormDataSaga = (
    validatedDataFromContactsPageForm: DataType,
): ActionType<DataType> => ({
    type: CONTACTS.START_SEND_USERS_DATA_SAGA,
    payload: validatedDataFromContactsPageForm,
});

/**
 * Perform request for saving users data to server
 * @param {DataType} userData - Received form data
 * @returns {ActionType<AxiosPromise>} - Returned action
 */
export const sendUserData = (userData: DataType): ActionType<AxiosPromise> => {
    const dataMap = {
        reason_inquiries: userData.reason,
        name: userData.name,
        email: userData.email,
        telephone: userData.phone,
        comment: userData.comment,
        file_1: userData.files[0],
        file_2: userData.files[1],
    };
    const data = new FormData();
    Object.keys(dataMap).forEach((key: string) => {
        data.append(key, dataMap[key]);
    });

    return {
        type: CONTACTS.SEND_USERS_DATA,
        payload: instanceGusaBackend({
            headers: {
                [HTTP_REQUEST_HEADER.CONTENT_TYPE]:
                    HTTP_REQUEST_HEADER_CONTENT_TYPE_VALUE.MULTIPART_FORM_DATA,
            },
            method: 'post',
            url: ENDPOINTS.CONTACT_US,
            data,
        }),
    };
};

/**
 * Sets notification popup content on contacts page
 * @param {string} message - Received message for notification
 * @returns {ActionType<string>} - Returned action
 */
export const setNotification = (message: string): ActionType<string> => ({
    type: CONTACTS.SET_NOTIFICATION,
    payload: message,
});

/**
 * Sets gratitude on button for contacts page form
 * @param {boolean} loading - Received status o form submitting
 * @returns {ActionType<boolean>} - Returned action
 */
export const setGratitude = (loading: boolean): ActionType<boolean> => ({
    type: CONTACTS.SET_GRATITUDE,
    payload: loading,
});
